import { render, staticRenderFns } from "./EventRecord.vue?vue&type=template&id=9cccd182&"
import script from "./EventRecord.vue?vue&type=script&lang=js&"
export * from "./EventRecord.vue?vue&type=script&lang=js&"
import style0 from "./EventRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports